<template>
  <!------------------ Hover Effect Style : Demo - 16 --------------->
       <div id="team" class="jumbotron team container-fluid">
            <div class="container w-75">
                <div class="row">
                    <div class="col-12 text-center mb-5">
                        <h1>Team</h1>
                    </div>
                    <div v-for="(member, index) in team" :key="index" class="member col-12 col-sm-6 col-md-4 col-lg-3 mb-3 p-1">
                        <div class="card">
                            <img class="img-fluid" :src="member.src">
                            <div class="capframe"></div>
                            <div class="caption pt-3">
                                <h5><b>{{member.name}}</b></h5>
                                <h6 v-html="member.position"></h6>
                                <div class="social">
                                    <span><a :href="`${member.li}`"><i class="fa fa-linkedin"></i></a></span>
                                    <span>&#124;</span>
                                    <span><a :href="`mailto:${member.email}`"><i class="fa fa-envelope"></i></a></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    name: 'Team',
    data(){
        return {
            team: [
                {
                    name: 'Tomás Cerna',
                    src: require('@/assets/img/TomasCerna.png'),
                    position: 'Chief Executive Officer<br>CoFounder',
                    email: 'tcerna@theprogressolabs.com',
                    li: 'https://www.linkedin.com/in/tom%C3%A1s-cerna-93210452/'
                },
                {
                    name: 'Christian Acosta',
                    src: require('@/assets/img/ChristianAcosta.png'),
                    position: 'Design Offer<br>CoFounder',
                    email: 'cacosta@theprogressolabs.com',
                    li: 'https://www.linkedin.com/in/christianacostaamaya/'
                },
                {
                    name: 'José Henríquez',
                    src: require('@/assets/img/JoseChavarria.png'),
                    position: 'Project Manager<br>CoFounder',
                    email: 'jchavarria@theprogressolabs.com',
                    li: 'https://www.linkedin.com/in/alphyon/'
                },
                {
                    name: 'Stanley Arévalo',
                    src: require('@/assets/img/StanleyArevalo.png'),
                    position: 'Quality Assurance<br>CoFounder',
                    email: 'sarevalo@theprogressolabs.com',
                    li: 'https://www.linkedin.com/in/stanley-arevalo/'
                },
                {
                    name: 'Rafael Alfaro',
                    src: require('@/assets/img/RafaelAlfaro.png'),
                    position: 'Infrastructure<br>CoFounder',
                    email: 'ralfaro@theprogressolabs.com',
                    li: 'https://www.linkedin.com/in/rafael-alfarosv/'
                }/*,
                {
                    name: 'Víctor Hernández',
                    src: require('@/assets/img/VictorHernandez.png'),
                    position: 'Mobile Developer'
                }*/
            ]
        }
    }
}
</script>

<style>

</style>